import { useEffect } from "react";

/**
 * Sets <meta name="robots"> for as long as the calling component is mounted,
 * then restores the site-wide default (index, follow) set in public/index.html.
 * Used for pages with no unique public content (e.g. the login-gated /ucet).
 */
export const useMetaRobots = (content) => {
  useEffect(() => {
    const tag = document.querySelector('meta[name="robots"]');
    const previous = tag?.getAttribute("content") ?? "index, follow";
    if (tag) tag.setAttribute("content", content);
    return () => {
      if (tag) tag.setAttribute("content", previous);
    };
  }, [content]);
};
